/* OutfitR 黑五/圣诞活动页(/pages/bfxmas)交互 — 仅被 sections/ofbf-*.liquid 引用。
   时间一律按美西(America/Los_Angeles)墙上时间判断；Liquid 首屏已按店铺时区渲染，这里在浏览器端复核(防页面缓存跨天)。
   验收用：?ofbf_demo=2026-11-03 或 ?ofbf_demo=2026-11-03T22:30 模拟日期(仅影响显示，未来闪购产品仍保密)。 */
(function () {
  if (window.__ofbfInit) return;
  window.__ofbfInit = true;

  var TZ = 'America/Los_Angeles';
  var DOW = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  /* ---------- 时间 ---------- */
  // PT 墙上时间按 UTC 存成毫秒；两个墙上时间相减即为剩余时长(DST 切换当天最多 1 小时误差)
  function wall(y, m, d, h, mi, s) { return Date.UTC(y, m - 1, d, h || 0, mi || 0, s || 0); }
  function ptWallNow() {
    var o = {};
    new Intl.DateTimeFormat('en-US', { timeZone: TZ, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' })
      .formatToParts(new Date()).forEach(function (p) { o[p.type] = +p.value; });
    return wall(o.year, o.month, o.day, o.hour, o.minute, o.second);
  }
  var demo = new URLSearchParams(location.search).get('ofbf_demo');
  var base = ptWallNow(), started = Date.now();
  if (demo && /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2})?$/.test(demo)) {
    var a = demo.split(/[-T:]/).map(Number);
    base = wall(a[0], a[1], a[2], a[3] || 9, a[4] || 0, 0);
  }
  function now() { return base + (Date.now() - started); }
  function dayKey(t) { var d = new Date(t); return d.getUTCFullYear() * 10000 + (d.getUTCMonth() + 1) * 100 + d.getUTCDate(); }
  function keyToWall(k) { return wall(Math.floor(k / 10000), Math.floor(k / 100) % 100, k % 100); }
  function nextDay(k) { return keyToWall(k) + 86400000; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ---------- Hero 阶段文案 + 两侧装饰 ---------- */
  function phaseFor(phases, k) {
    for (var i = 0; i < phases.length; i++) if (k <= phases[i].until) return phases[i];
    return phases[phases.length - 1];
  }
  function initHero(k) {
    var root = document.querySelector('[data-ofbf-hero]');
    if (!root) return null;
    var phases = [];
    try { phases = JSON.parse(root.getAttribute('data-phases') || '[]'); } catch (e) {}
    if (!phases.length) return root;
    var ph = phaseFor(phases, k);
    var h1 = root.querySelector('[data-h1]'), h2 = root.querySelector('[data-h2]'), tx = root.querySelector('[data-htext]');
    if (h1) h1.textContent = ph.l1;
    if (h2) h2.textContent = ph.l2;
    if (tx) tx.textContent = ph.text;
    if (root.getAttribute('data-deco') === 'true') initDeco(root, ph.deco || 'Black Friday');
    return root;
  }
  function initDeco(hero, word) {
    if (document.querySelector('.ofbf-deco')) return;
    var txt = new Array(9).join(word + ' · ');
    ['l', 'r'].forEach(function (side) {
      var el = document.createElement('div');
      el.className = 'ofbf-deco ofbf-deco--' + side;
      el.setAttribute('aria-hidden', 'true');
      el.innerHTML = '<div class="ofbf-deco__word"><div class="ofbf-deco__track"></div></div><div class="ofbf-deco__bulbs"></div>';
      el.querySelector('.ofbf-deco__track').textContent = txt + txt;
      document.body.appendChild(el);
    });
    var target = hero.querySelector('.ofbf-hero') || hero;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        document.querySelectorAll('.ofbf-deco').forEach(function (d) { d.classList.toggle('ofbf-show', !es[0].isIntersecting); });
      }, { threshold: 0.15 }).observe(target);
    }
  }

  /* ---------- 闪购 ---------- */
  var cdTargets = {};
  function initFlash(k) {
    var root = document.querySelector('[data-ofbf-flash]');
    if (!root) return;
    var slots = Array.prototype.slice.call(root.querySelectorAll('[data-slot]'));
    var keys = slots.map(function (s) { return +s.getAttribute('data-slot'); });
    // 提前开场：今天没有场次时，取最近一个带 data-early 的未来场次当作"进行中"
    var lk = k;
    if (keys.indexOf(k) < 0) {
      var early = root.querySelector('template[data-early]');
      if (early && +early.getAttribute('data-drop') > k) lk = +early.getAttribute('data-drop');
    }
    var liveIdx = keys.indexOf(lk);
    var nextIdx = -1;
    for (var i = 0; i < keys.length; i++) if (keys[i] > lk) { nextIdx = i; break; }
    if (liveIdx < 0 && nextIdx < 0) { root.hidden = true; return; }

    var tpls = liveIdx >= 0 ? Array.prototype.slice.call(root.querySelectorAll('template[data-drop="' + lk + '"]')) : [];
    var tpl = tpls[0] || null;
    // 当天应揭晓但页面里没有产品数据 → 多半是跨天前的缓存页，刷新一次(真实时间下才做)
    if (liveIdx >= 0 && !tpl && !demo) {
      var flag = 'ofbf-reload-' + k;
      try {
        if (!sessionStorage.getItem(flag)) {
          sessionStorage.setItem(flag, '1');
          var u = new URL(location.href); u.searchParams.set('ofbf_r', String(k)); location.replace(u.toString()); return;
        }
      } catch (e) {}
    }

    var q = function (s) { return root.querySelector(s); };
    var ring = q('[data-ring]');
    if (tpl) {
      var dt = new Date(keyToWall(lk));
      var day = DOW[dt.getUTCDay()] + ', ' + MON[dt.getUTCMonth()] + ' ' + dt.getUTCDate();
      var inner = q('.ofbf-booth__inner');
      // 同一天多款：每款复制一份完整展台(图 / 立省 / 价格 / 倒计时 / 按钮)上下展开，不用点击切换
      var panes = [inner];
      for (var j = 1; j < tpls.length; j++) {
        var c = inner.cloneNode(true);
        var soon = c.querySelector('[data-soon]'); if (soon) soon.parentNode.removeChild(soon);
        var path = c.querySelector('defs path'), tp = c.querySelector('textPath');
        if (path && tp) { path.id = path.id + '-' + j; tp.setAttribute('href', '#' + path.id); }
        c.classList.add('ofbf-booth__inner--more');
        inner.parentNode.appendChild(c);
        panes.push(c);
      }
      tpls.forEach(function (t, i) {
        var pane = panes[i], s = function (sel) { return pane.querySelector(sel); };
        s('[data-status]').innerHTML = '<span class="ofbf-live">Live now</span>' + (tpls.length > 1 ? 'Deal ' + (i + 1) + ' of ' + tpls.length + ' · ' : '') + day;
        s('[data-title]').textContent = t.getAttribute('data-name');
        s('[data-desc]').textContent = t.getAttribute('data-desc');
        s('[data-now]').textContent = t.getAttribute('data-price');
        var was = t.getAttribute('data-was');
        s('[data-was]').textContent = was; s('[data-was]').hidden = !was;
        var img = t.getAttribute('data-img');
        if (img) s('[data-disc]').innerHTML = '<img src="' + img + '" alt="">';
        var save = t.getAttribute('data-save');
        if (save) { s('[data-tag-amt]').textContent = save; s('[data-tag]').hidden = false; }
        var buy = s('[data-buy]');
        buy.href = t.getAttribute('data-url');
        if (t.getAttribute('data-available') !== 'true') { buy.textContent = 'Sold out'; buy.setAttribute('aria-disabled', 'true'); buy.removeAttribute('href'); }
        var r = s('[data-ring]');
        if (r) r.textContent = r.getAttribute('data-ring-live');
        s('[data-live]').hidden = false;
      });
      q('[data-soon]').hidden = true;
      requestAnimationFrame(function () { requestAnimationFrame(function () { root.querySelectorAll('[data-prices]').forEach(function (el) { el.classList.add('ofbf-go'); }); }); });
      cdTargets.live = nextDay(lk);
    }
    if (!tpl) {
      var n = keys[nextIdx >= 0 ? nextIdx : liveIdx];
      var nd = new Date(keyToWall(n));
      q('[data-status]').textContent = 'Next drop · ' + DOW[nd.getUTCDay()] + ', ' + MON[nd.getUTCMonth()] + ' ' + nd.getUTCDate() + ' · 12:00 AM PT';
      if (ring) ring.textContent = ring.getAttribute('data-ring-soon');
      q('[data-live]').hidden = true; q('[data-soon]').hidden = false;
      cdTargets.next = keyToWall(n);
    }

    slots.forEach(function (s, i) {
      var label = s.querySelector('[data-slot-label]');
      if (i === liveIdx && tpl) { s.classList.add('ofbf-is-live'); label.textContent = 'Live'; }
      else if (keys[i] < lk) { s.classList.add('ofbf-is-past'); label.textContent = 'Ended'; }
      else if (i === nextIdx) { s.classList.add('ofbf-is-next'); label.textContent = 'Next'; }
      else label.textContent = 'Soon';
    });
    initBooth(q('[data-booth]'));
  }

  /* ---------- 灯泡 ---------- */
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initBooth(box) {
    if (!box) return;
    var host = box.querySelector('[data-bulbs]');
    function draw() {
      var w = box.offsetWidth, h = box.offsetHeight, gap = 30, inset = 14, pts = [], html = '';
      if (!w || !h) return;
      var nx = Math.max(2, Math.round((w - inset * 2) / gap)), ny = Math.max(2, Math.round((h - inset * 2) / gap)), x, y;
      for (x = 0; x <= nx; x++) pts.push([inset + x * (w - inset * 2) / nx, inset]);
      for (y = 1; y <= ny; y++) pts.push([w - inset, inset + y * (h - inset * 2) / ny]);
      for (x = nx - 1; x >= 0; x--) pts.push([inset + x * (w - inset * 2) / nx, h - inset]);
      for (y = ny - 1; y >= 1; y--) pts.push([inset, inset + y * (h - inset * 2) / ny]);
      pts.forEach(function (p, i) { html += '<span class="ofbf-bulb ' + (i % 2 ? 'ofbf-b' : 'ofbf-a') + '" style="left:' + p[0] + 'px;top:' + p[1] + 'px"></span>'; });
      host.innerHTML = html;
    }
    draw();
    // 展台高度会随标题行数、图片和字体加载变化：尺寸一变就重排灯泡
    var rt, lastSize = '';
    function redraw() { clearTimeout(rt); rt = setTimeout(function () { var sz = box.offsetWidth + 'x' + box.offsetHeight; if (sz !== lastSize) { lastSize = sz; draw(); } }, 60); }
    if ('ResizeObserver' in window) new ResizeObserver(redraw).observe(box); else window.addEventListener('resize', redraw);
    window.addEventListener('load', redraw);
    var flip = false;
    function blink() { flip = !flip; box.classList.toggle('ofbf-on-a', flip || reduce); box.classList.toggle('ofbf-on-b', !flip || reduce); }
    blink();
    if (!reduce) setInterval(blink, 650);
  }

  /* ---------- 黑五正日等按日期显示的块 ---------- */
  function initWindows(k) {
    document.querySelectorAll('[data-ofbf-window]').forEach(function (el) {
      var from = +el.getAttribute('data-from'), to = +el.getAttribute('data-to');
      el.hidden = !(k >= from && k <= to);
      if (!el.hidden) cdTargets.window = nextDay(to);
    });
  }

  /* ---------- 配件区按日期切换文案 ---------- */
  function initAcc(k) {
    document.querySelectorAll('[data-ofbf-acc]').forEach(function (root) {
      var pick = root.querySelector('template[data-acc-default]');
      root.querySelectorAll('template[data-acc-copy]').forEach(function (t) {
        if (k >= +t.getAttribute('data-from') && k <= +t.getAttribute('data-to')) pick = t;
      });
      if (!pick) return;
      root.querySelector('[data-acc-eyebrow]').textContent = pick.getAttribute('data-eyebrow');
      root.querySelector('[data-acc-title]').textContent = pick.getAttribute('data-title');
      root.querySelector('[data-acc-accent]').textContent = pick.getAttribute('data-accent');
      root.querySelector('[data-acc-text]').textContent = pick.getAttribute('data-text');
    });
  }

  /* ---------- 配件直接加购(主题自带购物车抽屉)---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.ofbf [data-atc]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var label = btn.textContent;
    btn.disabled = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +btn.getAttribute('data-atc'), quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        btn.textContent = btn.getAttribute('data-added') || 'Added ✓';
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { detail: { opener: btn } }));
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2200);
      })
      .catch(function () { btn.textContent = 'Try again'; btn.disabled = false; });
  });

  /* ---------- 倒计时 ---------- */
  var lastKey;
  function tick() {
    var t = now(), k = dayKey(t);
    if (lastKey && k !== lastKey && !demo) { location.reload(); return; } // 跨过 PT 午夜：重新拉取页面(揭晓/切换阶段)
    lastKey = k;
    document.querySelectorAll('.ofbf [data-cd]').forEach(function (el) {
      var target = cdTargets[el.getAttribute('data-cd')];
      if (!target) return;
      var s = Math.max(0, Math.floor((target - t) / 1000));
      var v = [Math.floor(s / 86400), Math.floor(s % 86400 / 3600), Math.floor(s % 3600 / 60), s % 60];
      el.innerHTML = ['Days', 'Hrs', 'Min', 'Sec'].map(function (l, i) { return '<div><b>' + pad(v[i]) + '</b><small>' + l + '</small></div>'; }).join('');
    });
  }

  function init() {
    var k = dayKey(now());
    initHero(k);
    initFlash(k);
    initWindows(k);
    initAcc(k);
    tick();
    setInterval(tick, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
